import { render, staticRenderFns } from "./FormObjectState.vue?vue&type=template&id=10142cb3&"
import script from "./FormObjectState.vue?vue&type=script&lang=js&"
export * from "./FormObjectState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports